export interface LoginResponse {
  first_name: string;
  last_name: string;
  role: string;
  user_email: string;
  expenses_module_enabled: boolean;
  expenses_version: boolean;
  auto_grant_id: boolean;
  database_admin_module_enabled: boolean;
}

export enum Role {
  Admin = 'admin',
  DonationManager = 'donation_manager',
  DonorManager = 'donor_manager',
  ReadOnly = 'read_only',
  Auditor = 'auditor',
  DonorAuditor = 'donor_auditor',
  GrantReportManager = 'grant_report_manager',
  ExpenseReportManager = 'expense_report_manager',
  BudgetReportManager = 'budget_report_manager',
  DonorReportManager = 'donor_report_manager',
  ExpenseApprover = '_expense_approver',
  ExpenseAdmin = '_expense_admin',
  ExpenseSubmitter = '_expense_submitter',
  BudgetApprover = 'budget_approver',
  BudgetMember = 'budget_member',
  BudgetAdmin = 'budget_admin',
  BudgetSubmitter = 'budget_submitter',
  GrantSubmitter = 'grant_submitter',
  GrantMember = 'grant_member',
  GrantAdmin = 'grant_admin',
  UtilitiesAccess = 'utilities_access',
  PayeeSubmitter = 'payee_submitter',
  PayeeApprover = 'payee_approver',
  PayeeAdmin = 'payee_admin',
  AdvanceSubmitter = 'advance_submitter',
  AdvanceApprover = 'advance_approver',
  AdvanceAdmin = 'advance_admin',
  OrgReportManager = 'org_report_manager',
  PayeeReportManager = 'payee_report_manager',
  DefaultExpenseAdmin = 'default_expense_admin',
  DefaultExpenseApprover = 'default_expense_approver',
  DefaultExpenseSubmitter = 'default_expense_submitter',
  PayrollExpenseAdmin = 'payroll_expense_admin',
  PayrollExpenseApprover = 'payroll_expense_approver',
  PayrollExpenseSubmitter = 'payroll_expense_submitter',
  CustomExp3ExpenseApprover = 'custom_exp3_expense_approver',
  CustomExp3ExpenseAdmin = 'custom_exp3_expense_admin',
  CustomExp3ExpenseSubmitter = 'custom_exp3_expense_submitter',
  ExpenseApprovalControlAdmin = 'expense_approval_control_admin',
  VendorSubmitter = 'vendor_submitter',
  VendorApprover = 'vendor_approver',
  VendorAdmin = 'vendor_admin',
  PledgeManager = 'pledge_manager',
  DatabaseAdmin = 'database_admin'
}

export interface PermissionConfig {
  [route: string]: {
    [action: string]: Role[];
  };
}
